// tslint:disable:no-trailing-whitespace
// tslint:disable:member-ordering
import { AuthBaseEntity } from '../auth-base-entity';
import { Feature } from './feature';
import { License } from './license';

/// <code-import> Place custom imports between <code-import> tags

/// </code-import>

/// <module-code> Place module level code between <module-code> tags

/// </module-code>

export class Product extends AuthBaseEntity  {

  /// <code> Place custom code between <code> tags
  
  /// </code>

  // Generated code. Do not place code below this line.
  id!: number;
  angularGuardName?: string;
  createdAt!: Date;
  createdBy?: string;
  hasRole!: boolean;
  productDescription?: string;
  productName?: string;
  ts?: any;
  updatedAt!: Date;
  updatedBy?: string;
  features!: Feature[];
  licenses!: License[];
}

